import { GetBatchParameters } from "./RestService";

export function GetStringEmpty(str) {
    if (str == null)
    {
        return true;
    }
    else if (str.trim() == "")
    {
        return true;
    }
    return false;
}

export function GetArrayEmpty(arr) {
    if (arr == null)
    {
        return true;
    }
    else if (arr.length == 0)
    {
        return true;
    }
    return false;
}

export function GetEmpty(obj) {
    if (obj == null)
    {
        return true;
    }
    else if (Array.isArray(obj))
    {
        if (obj.length == 0)
        {
            return true;
        }
    }
    else if (typeof obj === 'string' || obj instanceof String)
    {
        if (obj.trim() == "")
        {
            return true;
        }
    }
    return false;
}

export function GetEmptyValue(obj, value) {
    if (obj == null)
    {
        return true;
    }
    if (!(value.toString() in obj))
    {
        return true;
    }
    if (obj[value] == null)
    {
        return true;
    }
    return false;
}

export function CheckMaterialsFound(resultMaterials, checkMaterials) {

    if (resultMaterials.length == 0)
    {
        return (checkMaterials.join(","));
    }
    else
    {
        var result = checkMaterials.filter(item => resultMaterials.indexOf(item) == -1);
        if (result.length > 0)
        {
            return (result.join(","));
        }
    }
    return "";
}

export function ConvertedTimeString(isoTime)
{
    var date = new Date(isoTime);
    var localTime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toLocaleString();
    return localTime;
}


export function getMatchingBatches(batches) {
    if (!Array.isArray(batches)) return [];
  
    return batches.filter(batch => {
      const args = batch.executeArguments || {};
      const relationships = args.relationships;
  
      const hasJobCompletedOrder = Array.isArray(batch.orders) &&
        batch.orders.some(order => order.status === "JOB COMPLETED");
  
      return (
        batch.status === "Success" &&
        args.levelOfScan === "deep_check" &&
        args.sendToCAD === "true" &&
        args.confPDM === "true" &&
        (
          relationships === "\"cws_configure_all_relationships\"" ||
          relationships === "\"cws_configure_has_part\""
        ) &&
        hasJobCompletedOrder
      );
    });
  }
  
export function FilterCharacteristics(defChars, tableOrders)
{
    const allowedCharNames = new Set(defChars.map(char => char.name));
        const updatedTableOrders = tableOrders == null ? null : tableOrders.map(order => {
  
        const filteredCharacteristics = Object.keys(order.characteristics)
            .reduce((acc, key) => {
            if (key === 'Description' || allowedCharNames.has(key)) {
                acc[key] = order.characteristics[key];
            }
            return acc;
            }, {});

            return {
                ...order,
                characteristics: filteredCharacteristics
            };
        }); 
    return updatedTableOrders;   
}

export async function LoadParameters(instance, batch)
{
    if (batch.s3DataLoaded) {
        if (batch && batch["orders"] && batch["orders"].length == 0) {
            batch.s3DataLoaded = false;
        } else {
            let tmpReturn = {};
            tmpReturn["orders"] = batch["orders"] || [];
            tmpReturn["defaultCharacteristics"] = batch["defaultCharacteristics"] || [];
            return tmpReturn; 
        }
    }

    try
    {
        const batchParameters = await GetBatchParameters(instance, batch["id"]);
        console.log("batchParameters: ", batchParameters);
        if(batchParameters && !batchParameters.exception) {
            console.log(`Loaded parameters from S3 for ${batch["id"]}`);
            batch["orders"] = batchParameters["orders"] || [];
            batch["defaultCharacteristics"] = batchParameters["defaultCharacteristics"] || [];
            batch.s3DataLoaded = true;
            return batchParameters;
        }

        if (batchParameters && batchParameters.exception) {
            if (batchParameters.exception.includes("not found") || batchParameters.exception.includes("Parameters not found")) {
                console.warn(`S3 file not found for ${batch["id"]}. Falling back to DDB data.`);
            } else {
                return {exception: batchParameters.exception};
            }
        }
        
    } catch (error) {
        if (error.message.includes("404") || error.message.includes("Not Found")) {
            console.warn(`S3 file not found for ${batch["id"]}. Falling back to DDB data.`);
        } else {
            console.error("Failed to get batch parameters:", error);
            return {exception: error};
        }
    }

    batch.s3DataLoaded = true; 
    
    batch["orders"] = batch["orders"] || [];
    batch["defaultCharacteristics"] = batch["defaultCharacteristics"] || [];

    let tmpReturn = {};
    tmpReturn["orders"] = batch["orders"];
    tmpReturn["defaultCharacteristics"] = batch["defaultCharacteristics"];
    console.log("tmpReturn: ", tmpReturn);
    return tmpReturn;
}